import { render, staticRenderFns } from "./SelectedChoices.vue?vue&type=template&id=2db3ad36&"
import script from "./SelectedChoices.vue?vue&type=script&lang=js&"
export * from "./SelectedChoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports